/* Created by Administrador on 16/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('routeList', {
                parent: 'app',
                url: '/route/list?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/route/routes.html',
                        controller: 'routeCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['route']);
                            }],
                            routes: ['$stateParams', 'routeService',function($stateParams, routeService){
                                return routeService.getRoutesPage($stateParams.page, $stateParams.size, true);
                            }]
                        }
                    }
                }
            })
            .state('routeNew', {
                parent: 'app',
                url: '/route/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/route/newRoute.html',
                        controller: 'newRouteCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['route']);
                            }]
                        }
                    }
                }
            })
            .state('routeEdit', {
                parent: 'app',
                url: '/route/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/route/editRoute.html',
                        controller: 'editRouteCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['route']);
                            }],
                            'routeObj': ['routeService','$stateParams', function(routeService,$stateParams){
                                return routeService.getRouteDetail($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('routeDetail', {
                parent: 'app',
                url: '/route/:id/details',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/route/viewDetail.html',
                        controller: 'viewDetailRouteCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['route']);
                            }],
                            'routeObj': ['routeService','$stateParams', function(routeService,$stateParams){
                                return routeService.getRouteDetail($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('routeDelete',{
                parent: 'routeList',
                url: '/route/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams','$state','$uibModal','linkService', function($stateParams,$state,$uibModal,linkService){
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/route/routeDelete.html',
                        controller: 'deleteRouteCtrl',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function() {
                        linkService.reloadRoute('routeList');
                    }, function() {
                        linkService.reloadRoute('^');
                    });
                }]
            })
    }
})();
